VLW.sliderWidth = class extends VLW.classBase {
	constructor(el, ctrl) {
		super();
		this.elt             = el;
		this.elt.vlwInstance = this;
		this.content         = {dom: this.elt.querySelector("._textGrid_content")};
		this.content.width   = this.content.dom.getBoundingClientRect().width;
		this.width           = this.elt.getBoundingClientRect().width + 5;
		this.nbColumn        = Math.ceil(this.content.width / this.width);
		if(this.nbColumn==1)return;
		this.grid            = {dom: this.elt.querySelector("._textGrid")};
		this.tracker = ThrowPropsPlugin.track(this.grid.dom,"x");
		this.dragCurs        = new Draggable.create(this.grid.dom, {
			type           : "x",
			dragClickables : true,
			edgeResistance : 1,
			dragResistance : 0.25,
			throwResistance: 5000,
			cursor         : "pointer",
			throwProps     : true,
			maxDuration    : 1,
			minDuration    : 1,
			snap           : this.snapDraggable
		});
		this.create_Elt();
		this.elt.addEventListener(EVENTS.MOUSEWHEEL, this.onWheel);
		this.updateNavigation(0);
	}

	onWheel(e) {
		let _d      = ((e.wheelDelta || e.detail * -120) > 0) ? -1 : 1;
		let _lisSel = this.elt.querySelector("._controlNav li.selected");
		let _index  = [..._lisSel.parentNode.children].indexOf(_lisSel);
		_index+=_d;
		_index = Math.max(_index,0);
		_index = Math.min(_index,_lisSel.parentNode.children.length-1);
		this.goTo(_index);
		e.preventDefault();
	}

	snapDraggable(end) {
		end          = Math.min(end, 0);
		let _return  = -(Math.floor(Math.abs(end) / this.width) * this.width);
		_return      = Math.min(_return, 0);
		_return      = Math.max(_return, -(this.content.width - this.width));
		let newIndex = Math.ceil(Math.abs(_return) / this.width);
		this.updateNavigation(newIndex);
		return _return;
	}

	create_Elt() {
		this.createControlNav();
	}

	createControlNav() {
		let ul       = document.createElement('ul');
		let createLi = (e, i) => {
			let li = document.createElement("li");
			li.addEventListener("click", this.clickControlNav);
			ul.appendChild(li);
		};
		ul.className = "_controlNav";
		Array.from(Array(this.nbColumn).keys()).forEach(createLi);
		this.elt.appendChild(ul);
		this.controlNav__li = this.elt.querySelectorAll("._controlNav li");
	}

	clickControlNav(e) {
		clearInterval(this.timer);
		this.goTo([...e.currentTarget.parentNode.children].indexOf(e.currentTarget));
	}

	goTo(pos) {
		this.updateNavigation(pos);
		let _veloX = this.tracker.getVelocity("x");
		
		if(_veloX==0) {
			TweenMax.to(this.grid.dom, 1, {x: -pos * this.width, ease: Power1.easeInOut});
		}else{
			let _t = ThrowPropsPlugin.to(this.grid.dom, {throwProps:{x:{velocity:"auto",end:(end)=>{return -pos * this.width}}, }},1,0.25);
			console.dir(_t._duration);
		}
	}

	updateNavigation(index) {
		this.controlNav__li.forEach((elt, i) => elt.classList.remove('selected'));
		this.controlNav__li[index].classList.add('selected');
	}

	instanceClean() {
	}
};